import { defineStore } from 'pinia'
import { ref } from 'vue'
import request from '@/utils/request'

export const useAvatarFrameStore = defineStore('avatarFrame', () => {
  const activeFrame = ref(null) // 当前激活的头像框
  const activeTitle = ref(null) // 当前激活的称号
  const loading = ref(false)

  // 加载当前激活的头像框
  const loadActiveFrame = async () => {
    try {
      const data = await request.get('/user/avatar-frames/me/active')
      activeFrame.value = data
    } catch (error) {
      activeFrame.value = null
    }
  }

  // 加载当前激活的称号
  const loadActiveTitle = async () => {
    try {
      const data = await request.get('/user/titles/me/active')
      activeTitle.value = data
    } catch (error) {
      activeTitle.value = null
    }
  }

  // 加载所有信息
  const loadAll = async () => {
    loading.value = true
    try {
      await Promise.all([
        loadActiveFrame(),
        loadActiveTitle()
      ])
    } finally {
      loading.value = false
    }
  }

  // 激活头像框
  const activateFrame = async (shopItemId) => {
    await request.post(`/user/avatar-frames/${shopItemId}/activate`)
    await loadActiveFrame()
  }

  // 取消激活头像框
  const deactivateFrame = async () => {
    await request.post('/user/avatar-frames/deactivate')
    activeFrame.value = null
  }

  // 激活称号
  const activateTitle = async (shopItemId) => {
    await request.post(`/user/titles/${shopItemId}/activate`)
    await loadActiveTitle()
  }

  // 取消激活称号
  const deactivateTitle = async () => {
    await request.post('/user/titles/deactivate')
    activeTitle.value = null
  }

  // 获取头像框配置（用于渲染）
  const getFrameConfig = () => {
    if (!activeFrame.value || !activeFrame.value.itemValue) return null
    
    try {
      // 尝试解析 JSON
      return JSON.parse(activeFrame.value.itemValue)
    } catch {
      // 如果不是 JSON，直接返回字符串（作为图片 URL）
      return activeFrame.value.itemValue
    }
  }

  // 获取称号配置（用于渲染）
  const getTitleConfig = () => {
    if (!activeTitle.value || !activeTitle.value.itemValue) return null
    
    try {
      // 尝试解析 JSON
      const parsed = JSON.parse(activeTitle.value.itemValue)
      // 如果解析成功，添加称号文本
      if (!parsed.text && !parsed.name && activeTitle.value.name) {
        parsed.text = activeTitle.value.name
      }
      return parsed
    } catch {
      // 如果不是 JSON，返回包含文本的对象
      return {
        text: activeTitle.value.name || activeTitle.value.itemValue
      }
    }
  }

  return {
    activeFrame,
    activeTitle,
    loading,
    loadActiveFrame,
    loadActiveTitle,
    loadAll,
    activateFrame,
    deactivateFrame,
    activateTitle,
    deactivateTitle,
    getFrameConfig,
    getTitleConfig
  }
})
